module.exports = __webpack_public_path__ + "static/media/gemo.477e308d.svg";